import { lazy } from 'react';

import Loadable from '../components/Loadable';
import DashboardLayout from '../layout/DashboardLayout';

const DashboardPage = Loadable(lazy(() => import('../pages/Dashboard')));
const CreatorsPage = Loadable(lazy(() => import('../pages/Creators')));
const UsersPage = Loadable(lazy(() => import('../pages/Users')));
const WithdrawalsPage = Loadable(lazy(() => import('../pages/Withdrawals')));
const StreamsPage = Loadable(lazy(() => import('../pages/Streams')));

const MainRoutes = {
    path: '/',
    element: <DashboardLayout />,
    children: [
        {
            path: '', element: <DashboardPage />
        },
        {
            path: 'creators', element: <CreatorsPage />
        },
        {
            path: 'users', element: <UsersPage />
        },
        {
            path: 'withdrawals', element: <WithdrawalsPage />
        },
        {
            path: 'streams', element: <StreamsPage />
        }
    ]
};

export default MainRoutes;